import React from 'react'
import { t } from 'src/translations'
import CheckoutSection from 'public/components/default_template/online_ordering/checkout/CheckoutSection'
import CreateAccountCheckbox from 'public/components/default_template/online_ordering/checkout/CreateAccountCheckbox'
import { useCustomer } from 'public/components/online_ordering/CustomerContextCommon'
import {
  MarketingSubscriptionCheckbox,
  MarketingSubscriptionCheckboxLegalText
} from 'public/components/default_template/online_ordering/checkout/marketing/MarketingSubscriptionCheck'
import { useMarketing } from 'public/components/online_ordering/MarketingContext'
import { useFormContext, useWatch } from 'react-hook-form'
import { useCheckout } from 'public/components/online_ordering/CheckoutContext'
import { useResetDisableAccountCreation } from './useResetDisableAccountCreation'

const StayInTouchSection = () => {
  const { customer } = useCustomer()
  const { disableAccountCreation } = useCheckout()
  const {
    smsAccountEnabled,
    subscribeToSmsMarketing,
    setSubscribeToSmsMarketing,
    subscribeToEmailMarketing,
    setSubscribeToEmailMarketing
  } = useMarketing()
  const phoneNumber = useWatch({ name: 'yourInfoPhone' })
  const {
    formState: { errors }
  } = useFormContext()

  // Reset account creation when phone number changes
  useResetDisableAccountCreation()

  if (customer) {
    return null
  }
  return (
    <CheckoutSection title={t('stay-in-touch-section.stay-in-touch')}>
      {!disableAccountCreation && <CreateAccountCheckbox />}
      {smsAccountEnabled && (
        <MarketingSubscriptionCheckbox
          name='subscribeToSmsMarketing'
          legalText={MarketingSubscriptionCheckboxLegalText.SMS}
          isActive={subscribeToSmsMarketing}
          setActive={setSubscribeToSmsMarketing}
          disabled={
            !phoneNumber || Object.keys(errors).includes('yourInfoPhone')
          }
        />
      )}
      <MarketingSubscriptionCheckbox
        name='subscribeToEmailMarketing'
        legalText={MarketingSubscriptionCheckboxLegalText.EMAIL}
        isActive={subscribeToEmailMarketing}
        setActive={setSubscribeToEmailMarketing}
      />
    </CheckoutSection>
  )
}

export default StayInTouchSection
